export default __webpack_public_path__ + "static/parigi-plus-1-5838b75aa0ad8c9f104f16751d6437e7.jpg";